export default __webpack_public_path__ + "static/media/phonegap-bot.06241a50.svg";